module.exports = __webpack_public_path__ + "static/main-ui-bb0a37d865853a4c9045562f18021d4b.png";